module.exports = __webpack_public_path__ + "img/HiwaQader-SebariBa.c96b1fa3.jpg";